import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {validadorClienteResources} from "../endpoints";

class DialogAgregarEditarValidadorCliente extends React.Component{
    constructor(props) {
        super(props);
        if(props.validador_cliente === null){
            this.state={
                title: 'Agregar validador cliente',
                cod_operador: '',
                rut:"",
                nombre:"",
                apellido1: "",
                apellido2: "",
            }
        }
        else{
            this.state={
                cod_operador:props.validador_cliente.cod_operador,
                title:'Editar validador cliente',
                rut:props.validador_cliente.rut,
                nombre: props.validador_cliente.nombre1,
                apellido1: props.validador_cliente.apellido1,
                apellido2: props.validador_cliente.apellido2,
            }
        }
    }

    agregarValidadorCliente = () =>{
        const datosValidador={
            cod_operador: this.state.cod_operador,
            rut:this.state.rut,
            nombre: this.state.nombre,
            apellido1: this.state.apellido1,
            apellido2: this.state.apellido2,
        }
        validadorClienteResources.createValidador(datosValidador).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }


    editarValidadorCliente = () =>{
        const datosValidador={
            cod_operador: this.state.cod_operador,
            rut:this.state.rut,
            nombre: this.state.nombre,
            apellido1: this.state.apellido1,
            apellido2: this.state.apellido2,
        }
        validadorClienteResources.editarValidadorCliente(datosValidador,this.state.cod_operador).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value})
    };

    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.state.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            <TextField
                                id="standard-multiline-flexible"
                                label="Rut (Sin Dígito)"
                                type={'number'}
                                fullWidth
                                rowsMax={5}
                                autoFocus
                                name={"rut"}
                                value={this.state.rut}
                                onChange={this.handleChange}
                                onInput = {(e) =>{
                                    e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,8)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="standard-multiline-flexible"
                                label="Nombres"
                                fullWidth
                                rowsMax={5}
                                name={"nombre"}
                                value={this.state.nombre}
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="standard-multiline-flexible"
                                label="Apellido paterno"
                                fullWidth
                                rowsMax={5}
                                name={"apellido1"}
                                value={this.state.apellido1}
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="standard-multiline-flexible"
                                label="Apellido materno"
                                fullWidth
                                rowsMax={5}
                                name={"apellido2"}
                                value={this.state.apellido2}
                                onChange={this.handleChange}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    {
                        this.state.title === "Editar validador cliente" && <Button
                            disabled={!this.state.rut || !this.state.nombre || !this.state.apellido1 || !this.state.apellido2}
                            variant="contained" color="primary"  onClick={this.editarValidadorCliente}>
                        Guardar
                        </Button>
                    }
                    {
                        this.state.title === "Agregar validador cliente" && <Button
                            disabled={!this.state.rut || !this.state.nombre ||  !this.state.apellido1 || !this.state.apellido2}
                            variant="contained" color="primary" onClick={this.agregarValidadorCliente}>
                            Guardar
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogAgregarEditarValidadorCliente;